import script from "./ProfileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProfileMenu.vue?vue&type=style&index=0&id=09465331&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09465331"]])

export default __exports__